import React, {useEffect, useState} from 'react';
import './BuyMaterialFactorPO.scss';
import FormSideFactor from "./FormSideFactor/FormSideFactor";
import TableSideFactor from "./TableSideFactor/TableSideFactor";

const BuyMaterialFactorPO = () => {

    const [initialData, setInitialData] = useState({});
    const [totalPriceTable, setTotalPriceTable] = useState(0);

    useEffect(() => {
        setInitialData({
            productList: [
                {productId: "11", name: "کاغز A4", ghVahed: "50000", offer: "5000", vzReject: "بله", te: "1"},
                {productId: "12", name: "کاغز A5", ghVahed: "100000", offer: "10000", vzReject: "بله", te: "1"},
                {productId: "13", name: "کاغز A6", ghVahed: "500000", offer: "50000", vzReject: "بله", te: "1"},
                {productId: "14", name: "کاغز A7", ghVahed: "200000", offer: "100000", vzReject: "بله", te: "1"},
                {productId: "15", name: "کاغز A8", ghVahed: "10000000", offer: "200000", vzReject: "بله", te: "1"},
            ],
            payType: [
                {label: "پرداخت از حساب بانکی", value: "1"},
                {label: "پرداخت از صندوق", value: "2"},
                {label: "حساب دفتری", value: "3"}
            ],
            rejectType: [
                {label: "مرجوع داده نشد", value: "1"},
                {label: "مرجوع کل فاکتور", value: "2"},
            ]
        })
    }, [])

    return (

        <div className="main-buy-material-factor">

            <div className="parent-form-side">
                {initialData.productList &&
                    <FormSideFactor initialData={initialData}
                                    totalPriceTable={totalPriceTable}/>
                }
            </div>

            <div className="parent-table-side">
                {initialData.productList &&
                    <TableSideFactor initialData={initialData}
                                     totalPriceTable={totalPriceTable}
                                     setTotalPriceTable={setTotalPriceTable}/>
                }
            </div>

        </div>
    );
};

export default BuyMaterialFactorPO;